'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initWixData = initWixData;
exports.navigationIn = navigationIn;
exports.videoPlayModeChanged = videoPlayModeChanged;
exports.videoEnded = videoEnded;
exports.videoAdded = videoAdded;
exports.videoRemoved = videoRemoved;
exports.galleryWindowLayoutChanged = galleryWindowLayoutChanged;
exports.editorModeChanged = editorModeChanged;
exports.toggleHoverPreview = toggleHoverPreview;
exports.toggleIsInView = toggleIsInView;

var _index = require('../utils/index');

var _index2 = _interopRequireDefault(_index);

var _WixSdkWrapper = require('photography-client-lib/dist/src/sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _galleryTypes = require('../constants/galleryTypes.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initWixData() {
  if (_index2.default.isInWix() && !_index2.default.isDemo()) {
    return function (dispatch) {
      _WixSdkWrapper2.default.getBoundingRectAndOffsets(function (res) {
        dispatch({
          type: _galleryTypes.SET_WIX_DATA,
          boundingRectAndOffsets: res
        });
      });
    };
  } else {
    return {
      type: _galleryTypes.SET_WIX_DATA
    };
  }
}

// export function setItems(items) {
//     return {
//         items: items,
//         type: SET_ITEMS
//     }
// }
//
//
// export function setRenderedItemsCount(count) {
//     return {
//         count: count,
//         type: SET_RENDERED_ITEMS_COUNT
//     }
// }

function navigationIn() {
  return {
    type: _galleryTypes.NAVIGATION_IN
  };
}

function videoPlayModeChanged(videoPlayMode) {
  return {
    videoPlayMode: videoPlayMode,
    type: _galleryTypes.VIDEO_PLAY_MODE
  };
}

function videoEnded(idx) {
  return {
    type: _galleryTypes.VIDEO_ENDED
  };
}

function videoAdded(videoData) {
  return {
    payload: videoData,
    type: _galleryTypes.VIDEO_ADDED
  };
}

function videoRemoved(index) {
  return {
    type: _galleryTypes.VIDEO_REMOVED,
    payload: index
  };
}

function galleryWindowLayoutChanged(_ref) {
  var documentHeight = _ref.documentHeight;

  return {
    documentHeight: documentHeight,
    type: _galleryTypes.GALLERY_WINDOW_LAYOUT_CHANGED
  };
}

function editorModeChanged() {
  return {
    type: _galleryTypes.EDITOR_MODE_CHANGED
  };
}

function toggleHoverPreview(toggle) {
  return {
    type: _galleryTypes.TOGGLE_HOVER_PREVIEW,
    toggle: toggle
  };
}

function toggleIsInView(toggle) {
  return {
    type: _galleryTypes.TOGGLE_ISINVIEW,
    toggle: toggle
  };
}